module.exports = __webpack_public_path__ + "img/case-study-royal-mint.a0e8151e.png";